import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';

@Component({
    selector: 'cs-gradient-number',
    templateUrl: './gradient-number.component.html',
    styleUrls: ['./gradient-number.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class GradientNumberComponent implements OnInit {
    readonly gradientIndex = input.required<number>();
    readonly SINGLE_DIGIT_THRESHOLD = 9;
    readonly customGradientClassMap: { [key: number]: string } = {
        1: 'gradient-number-wrapper-for-one',
        10: 'gradient-number-wrapper-for-ten',
    };
    isMultipleDigit: boolean;
    customClassBasedOnNumber: string;

    ngOnInit() {
        this.isMultipleDigit = this.gradientIndex() > this.SINGLE_DIGIT_THRESHOLD;
        this.customClassBasedOnNumber = this.customGradientClassMap[this.gradientIndex()] || 'gradient-number-wrapper-for-others';
    }
}
